module.exports = __webpack_public_path__ + "static/img/02_02_compressor.1bcc5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_02_compressor.png
// module id = r/P9
// module chunks = 12